import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get walk list 
export const getWalk = createAsyncThunk("walk/get-walkthrough ", async (data) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/crm/app/v1/get-walkthroughs`, data, { 
            headers: {
                "auth-token": token,
            }
        },);
        console.log({ response })
        return response;
    } catch (error) {
        console.error('Error fetching Walkthrough - ', error);
        throw error;
    }
})


